import styled from "styled-components";

export const Styles = styled.div`
  .input-field.timer {
    border: none;
    background: transparent;
    box-shadow: none;
  }

  .ant-input,
  .ant-input-affix-wrapper > input.ant-input {
    background: transparent;
  }

  .ant-input-suffix {
    color: rgba(0, 0, 0, 0.25);
  }
`;
